// removed by extract-text-webpack-plugin
module.exports = {"ipad":"1024px","white":"#ffffff","dark-purple":"#4a2e5e","light-purple":"#a096c8","background-grey":"#f6f6f6","yellow":"#fdc400","wrapper":"_2tQS8H__Jp6G714gxL49x1","container":"_2nA2CO1-6a9_xF0jXkx8mP","title":"_1FrLFV7l47hm7HJBluVpzO","highlight":"Z6zDLdMZOOkflQlU2HtgH","description":"_1RFuAYT1U9IFb1Qq-8JDVh","v2":"y2VB6p6ntbh_TuwM2Usvc","link":"_1mnN-fI5pvpf2mJyhwn_U7","illustration":"_2NHfZDuqLWP9qH3ahLQ3BV"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Hotspots/Selfcare/HotspotB/HotspotSelfcareB.css
// module id = 1475
// module chunks = 0